import * as React from 'react';
import { FormField, TimeInput } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export var TimeField = function TimeField(_ref) {
  var disabled = _ref.disabled,
    error = _ref.error,
    label = _ref.label,
    onChange = _ref.onChange,
    value = _ref.value;
  return /*#__PURE__*/_jsx(FormField, {
    label: label,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx(TimeInput, {
      "data-testid": "time-input",
      onChange: onChange,
      value: value,
      disabled: disabled,
      invalid: !!error
    })
  });
};
TimeField.displayName = 'TimeField';